import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PrivateRoute from "./components/PrivateRoute";
import SignInPage from "./pages/SignInPage";
import { useDispatch } from "react-redux";
import { setUser } from "./redux/slices/authSlice";
import { useEffect } from "react";
import BlogListPage from "./pages/BlogListPage";
import AddBlogPage from "./pages/AddBlogPage";
import ManageAdminPage from "./pages/ManageAdminPage";
import SiteDetailsPage from "./pages/SiteDetailsPage";
import ContactListPage from "./pages/ContactListPage";
import CategoryPage from "./pages/CategoryPage";
import PagesPage from "./pages/PagesPage";
import PageEditorPage from "./pages/PageEditorPage";
import EditPageEditorPage from "./pages/EditPageEditorPage";
import UsersListPage from "./pages/UsersListPage";
import EditBlogPage from "./pages/EditBlogPage";
import AdminMessagesPage from "./pages/AdminMessagesPage"


function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (user && token) {
      dispatch(setUser({ user: JSON.parse(user), token }));
    }
  }, [dispatch]);


  return (

    <BrowserRouter>

      <RouteScrollToTop />

      <Routes>

        <Route path="/login" element={<SignInPage />} />

        {/* 🔐 Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<HomePageOne />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/users" element={<UsersListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-categories" element={<CategoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-admin" element={<ManageAdminPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/add-blog" element={<AddBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-blog/:id" element={<EditBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-blogs" element={<BlogListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/contacts" element={<ContactListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/update-site-details" element={<SiteDetailsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/page-editor" element={<PageEditorPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-page/:slug" element={<EditPageEditorPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/pages" element={<PagesPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/admin-message" element={<AdminMessagesPage />} />
        </Route>

        {/* ❌ Fallback */}
        <Route path="*" element={<ErrorPage />} />

      </Routes>

    </BrowserRouter>

  );
}

export default App;
